import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from 'modules/global/adapters';
import { BulkReleaseRightActionRequest } from 'modules/global/adapters/crpAPI';
import { acceptReleaseRightKeys } from './queryKeys';

export const useGetActiveTerminals = () => {
  return useQuery(acceptReleaseRightKeys.getTerminals(), () => api.terminals.getTerminals());
};

export const useGetPendingContainers = () => {
  return useQuery(acceptReleaseRightKeys.getPendingContainersForReleaseRightAction(), () =>
    api.containers.getPendingContainersForReleaseRightAction()
  );
};

export const usePostContainersAccept = () => {
  const queryClient = useQueryClient();

  return useMutation(acceptReleaseRightKeys.postContainersAccept(), {
    mutationFn: (data: BulkReleaseRightActionRequest) =>
      api.releaserights.postContainersAccept(data),
    onSuccess: () => {
      queryClient.invalidateQueries(acceptReleaseRightKeys.containersForUpdateRoot());
    },
  });
};

export const useGetContainerDetail = (id: string) => {
  return useQuery(acceptReleaseRightKeys.getContainerDetail(id), () =>
    api.containers.getContainerDetail(id)
  );
};
